import { useMemo } from 'react';
import { orderBy } from 'lodash';

import { isLongFormProject } from 'src/data/project';
import { TEMPLATE_STATUS } from 'src/data/templates';
import { createStateSelectorHook } from 'src/lib/sweetState';
import { usePrepareMultiPromptTemplates } from 'src/services';
import { MultiPromptTemplatesStore } from 'src/store';

const useMultiPromptTemplatesState = createStateSelectorHook(MultiPromptTemplatesStore, [
  'multiPromptTemplates',
  'loadingMultiPromptTemplates',
]);

export const useLongFormMultiPromptTemplates = () => {
  const { multiPromptTemplates, loadingMultiPromptTemplates } = useMultiPromptTemplatesState();
  const preparedMultiPromptTemplates = usePrepareMultiPromptTemplates(multiPromptTemplates);

  return useMemo(() => {
    const filteredTemplates = preparedMultiPromptTemplates.filter(
      (t) => isLongFormProject(t.projectType) && t.status !== TEMPLATE_STATUS.draft
    );

    const sortedTemplates = orderBy(filteredTemplates, ['status'], ['desc']);

    return {
      longFormMultiPromptTemplates: sortedTemplates,
      loadingMultiPromptTemplates,
    };
  }, [preparedMultiPromptTemplates, loadingMultiPromptTemplates]);
};
